export const REQUEST_FAQ_LIST = 'REQUEST_FAQ_LIST'